import * as React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";

import Designer from "./designer/designer";
import { Unauthorize } from "./errors/unauthorize";
import "storm-react-diagrams/dist/style.min.css";
import { ModalNotificationGlobal } from "./utils/modalNotificationGlobal";

import {
    // Collapse,
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    // NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import { ScenariosTable } from "./scenarios/scenarios";
import { ScenariosDialoghiAttiviTable } from "./scenarios/scenarios-exportDialoghiAttivi";
import { ScriptsTable } from "./scripts/scripts";
import { CreateOrderTable } from "./createorder/createorder";

import i18n from "./i18n";
import { MessagesTable } from "./messages/messages-list";

import { settings } from "./settings";
import { SSMLTable } from "./ssml-library/ssml-list";
import { getUserName, checkRole, role } from "./security/security";
import { ContentsTable } from "./contents/contents";
import { UserRoles } from "./userRoles/userRoles";
import Loader from "./shared/loader/loader";
import { ToastsContainerPosition, ToastsContainer, ToastsStore } from "react-toasts";
import { ReleaseManagement } from "./release-management/release-management";

export interface AppProps { }
export interface AppState { }

class App extends React.Component<AppProps, AppState> {

    constructor(props: AppProps) {
        super(props);
    }

    private showPage(url: string) {
        return settings.pages.filter((p: string) => p === url).length > 0;
    }

    componentDidMount() {
        this.writeVersionToConsole(settings.trainingCenterVersionUrl, "Training Center");
        this.writeVersionToConsole(settings.botVersionUrl, "Bot");

    }

    private writeVersionToConsole(url: string, componentName: string) {
        fetch(url)
            .then(response => {
                response.text().then(function (text: string) {
                    // commented to avoid security warning by some tools. Enable as needed to debug
                    // console.log(componentName + " version: " + text);
                });
            });
    }

    render() {
        return (
            <Router>
                <div className="App">
                    <Loader />
                    <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.BOTTOM_RIGHT} />
                    <Navbar color="dark" dark={true} expand="md" fixed="top">
                        <NavbarBrand>
                            <img src="/Bot.png" alt="Bot" />
                            {i18n.Global.ApplicationTitle + " - " + role + ": " + getUserName()}
                        </NavbarBrand>
                        <Nav className="ml-auto" navbar={true}>
                            {checkRole("Designer.Display") &&
                                (<NavItem>
                                    <Link to="/" className="nav-link">
                                        {i18n.Global.Navigation.Designer}
                                    </Link>
                                </NavItem>)
                            }
                            {this.showPage("/scenarios") && checkRole("Scenarios.Display") && (
                                <NavItem>
                                    <Link to="/scenarios" className="nav-link">
                                        {i18n.Global.Navigation.Scenarios}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/scenarios-exportDialoghiAttivi") && checkRole("Scenarios.Display") && (
                                <NavItem>
                                    <Link to="/scenarios-exportDialoghiAttivi" className="nav-link">
                                        {i18n.Global.Navigation.ScenariosExportDialoghiAttivi}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/scripts") && checkRole("Scripts.Display") && (
                                <NavItem>
                                    <Link to="/scripts" className="nav-link">
                                        {i18n.Global.Navigation.Scripts}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/createorders") && checkRole("CreateOrders.Display") && (
                                <NavItem>
                                    <Link to="/createorders" className="nav-link">
                                        {i18n.Global.Navigation.CreateOrders}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/contents") && checkRole("Contents.Display") && (
                                <NavItem>
                                    <Link to="/contents" className="nav-link">
                                        {i18n.Global.Navigation.Contents}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/messages") && checkRole("Messages.Display") && (
                                <NavItem>
                                    <Link to="/messages" className="nav-link">
                                        {i18n.Global.Navigation.Messages}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/ssml") && checkRole("Ssml.Display") && (
                                <NavItem>
                                    <Link to="/ssml" className="nav-link">
                                        {i18n.Global.Navigation.SSMLLibrary}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/userRoles") && checkRole("UserRoles.Display") && (
                                <NavItem>
                                    <Link to="/userRoles" className="nav-link">
                                        {i18n.Global.Navigation.RoleManagement}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showPage("/release") && checkRole("Release.Change") && (
                                <NavItem>
                                    <Link to="/release" className="nav-link">
                                        {i18n.Global.Navigation.ReleaseManagement}
                                    </Link>
                                </NavItem>
                            )}
                            {this.showUsefulLinks()}
                        </Nav>
                    </Navbar>

                    <div className="App-intro">
                        {/* https://reacttraining.com/react-router/web/guides/quick-start */}
                        <Route exact={true} path="/" component={Designer} />
                        {this.showPage("/scenarios") && (
                            <Route path="/scenarios" component={ScenariosTable} />
                        )}
                        {this.showPage("/scenarios-exportDialoghiAttivi") && (
                            <Route path="/scenarios-exportDialoghiAttivi" component={ScenariosDialoghiAttiviTable} />
                        )}
                        {this.showPage("/scripts") && (
                            <Route path="/scripts" component={ScriptsTable} />
                        )}
                        {this.showPage("/createorders") && (
                            <Route path="/createorders" component={CreateOrderTable} />
                        )}
                        {this.showPage("/contents") && (
                            <Route path="/contents" component={ContentsTable} />
                        )}
                        {this.showPage("/messages") && (
                            <Route path="/messages" component={MessagesTable} />
                        )}
                        {this.showPage("/ssml") && (
                            <Route path="/ssml" component={SSMLTable} />
                        )}
                        {this.showPage("/userRoles") && (
                            <Route path="/userRoles" component={UserRoles} />
                        )}
                        {this.showPage("/release") && (
                            <Route path="/release" component={ReleaseManagement} />
                        )}
                        <Route path="/unauthorize" component={Unauthorize} />
                        {this.getStartupPage()}
                    </div>
                    <ModalNotificationGlobal />
                </div>
            </Router>
        );
    }

    private getStartupPage(): any {
        if (role) {
            if (checkRole("Contents.AtStartup")) {
                return <Redirect to="/contents"/>
            }
        } else {
            return <Redirect to="/unauthorize"/>
        }
    }

    private showUsefulLinks() {
        return settings.links && settings.links.length > 0 &&
            (
                <UncontrolledDropdown>
                    <DropdownToggle>
                        Links
                    </DropdownToggle>
                    <DropdownMenu>
                        {settings.links.map((l: any) => this.renderLink(l))}
                    </DropdownMenu>
                </ UncontrolledDropdown>
            );
    }

    private renderLink(link: any) {
        return (
            <DropdownItem>
                <Link to={link.url} target="_blank">
                    {link.name}
                </Link>
            </DropdownItem>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx